import { useEffect, useRef } from 'react';

// Returns the previous prop/state value before update.
export const usePrevious = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
